<template>
    <dialog-window
        @click.native.stop
        :show="show"
        v-bind="dialogProps"
        :closeOnClickOutside="dialogProps.closeOnClickOutside === undefined ? true : dialogProps.closeOnClickOutside"
        :closeOnEscape="dialogProps.closeOnEscape === undefined ? true : dialogProps.closeOnEscape"
        @closed="onOk"
        style="z-index: 1007;"
    >
        <template v-if="header" v-slot:header>
            <i v-show="headerIcon" :class="headerIcon" style="margin-right: 0.3em"></i>
            {{ header }}
        </template>
        <template v-if="type === 'info'" v-slot:body>
            <component
                v-bind="bodyComponentProps"
                v-if="componentName"
                :is="componentName"
                @closed="onOk"
            ></component>
            <div v-else v-html="body" class="info-label"></div>
        </template>
        <template v-slot:footer>
            <button
                class="button primary full-width icon"
                ref="ok"
                @click="onOk"
                :style="okStyles"
            >
                <i v-show="okIcon" :class="okIcon"></i>
                {{ okText }}
            </button>
        </template>
    </dialog-window>
</template>
<script>
    import { mapGetters } from 'vuex';

    export default {
        name: 'DialogInfo',
        data() {
            return {};
        },
        props: {
            show: {
                type: Boolean,
                required: true
            }
        },
        computed: {
            ...mapGetters({
                header: 'dialog/header',
                headerIcon: 'dialog/headerIcon',
                okText: 'dialog/okText',
                okIcon: 'dialog/okIcon',
                okStyles: 'dialog/okStyles',
                componentName: 'dialog/componentName',
                bodyComponentProps: 'dialog/bodyComponentProps',
                dialogProps: 'dialog/dialogProps',
                body: 'dialog/body',
                ok: 'dialog/ok',
                type: 'dialog/type'
            })
        },
        methods: {
            onOk() {
                this.ok();
                this.$store.dispatch('dialog/clear');
            }
        }
    };
</script>